import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { DragAndDropModeService } from '@wilson/shift-timeline/services';
import { SetDemarcatorRange } from '@wilson/shift-timeline/state';
import {
  GanttDateToPositionPxPipe,
  DropZoneEventThrottlerDirective,
} from '@wilson/shift-timeline/assignments-gantt-chart';

@Component({
  selector: 'wilson-activity-reset-drop-zone',
  imports: [],
  template: '',
  styleUrls: ['./activity-reset-drop-zone.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [GanttDateToPositionPxPipe],
})
export class ActivityResetDropZoneComponent extends DropZoneEventThrottlerDirective {
  private readonly store = inject(Store);
  readonly dragAndDropModeService = inject(DragAndDropModeService);

  protected onDragOverHandler(): void {
    // No Implementation Needed
  }

  protected onDragLeaveHandler(): void {
    // No Implementation Needed
  }

  protected onDropHandler() {
    this.store.dispatch(new SetDemarcatorRange([]));
    this.dragAndDropModeService.setActivityDropZone(false);
    this.dragAndDropModeService.setMoveActivityDropZone(false);
    this.dragAndDropModeService.setDraggingItemId(null);
  }
}
